import { keepPreviousData } from '@tanstack/react-query'

/** Shared TanStack Query options for redemption option list endpoints (parent + tab forms). */
export const redemptionListQueryOptions = {
  refetchOnWindowFocus: true,
  staleTime: 1000 * 60 * 5,
  gcTime: 1000 * 60 * 10,
  placeholderData: keepPreviousData,
} as const
